import { AuthService } from './../services/auth.service';
import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";


@Injectable()
export class APIInterceptor implements HttpInterceptor {

  url: string;
  token: string;

  constructor(private AuthService: AuthService) {
    const { accessToken } = this.AuthService.getUser();
    this.token = accessToken;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (request.url.match(/^(?:(?:\w+:\/\/)|\/)/) === null) {
        let apiRequest = request.clone({ url: `${environment.api.backend.replace(/\/$/, '')}/${request.url}` });
        if (this.token) {
          apiRequest = apiRequest.clone({ setHeaders: { 'Authorization': `Bearer ${this.token}` } });
        }
        return next.handle(apiRequest);
      }
    return next.handle(request);

    //Trocar depois o de cima por esse jefferson@condominioapp.com
    // const requestUrl: Array<any> = request.url.split('/');
    // const apiUrl: Array<any> = environment.api.split('/');
    // const token = localStorage.getItem('marketplaceToken');

    // if (token && requestUrl[2] === apiUrl[2]) {
    //   const newRequest = request.clone({ setHeaders: { 'Authorization': `Bearer ${token}` } });

    //   return next.handle(newRequest);
    // } else {
    //   return next.handle(request);
    // }
  }
}
